// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"Callout__tooltipContainer__36kZo","title":"Callout__title__2od6f","triangle":"Callout__triangle__KZ7ri","close":"Callout__close__3dkGO","closeButton":"Callout__closeButton__2OATl","divider":"Callout__divider__CmCNu","text":"Callout__text__2Hy3r"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Callout/Callout.scss
// module id = 622
// module chunks = 4 6 8 9 10 14 55 56